import * as React from 'react';
import Stack from '@mui/material/Stack';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import capitalize from '@mui/utils/capitalize';

import { EventTimelinePremium } from '@mui/x-scheduler-premium/event-timeline-premium';
import { defaultVisibleDate } from '../../datasets/company-roadmap';

const initialEvents = [
  // July 1, 2025 (defaultVisibleDate) - Tuesday schedule

  // 8:00-9:30 AM slots
  {
    id: 'math-1-room-a',
    start: '2025-07-01T08:00:00',
    end: '2025-07-01T09:30:00',
    room: 'Room A',
    teacher: 'french',
  },
  {
    id: 'science-1-room-b',
    start: '2025-07-01T08:00:00',
    end: '2025-07-01T09:30:00',
    room: 'Room B',
    teacher: 'science',
  },
  {
    id: 'english-1-room-c',
    start: '2025-07-01T08:00:00',
    end: '2025-07-01T09:30:00',
    room: 'Room C',
    teacher: 'english',
  },
  // 10:00-11:30 AM slots
  {
    id: 'history-1-room-a',
    start: '2025-07-01T10:00:00',
    end: '2025-07-01T11:30:00',
    room: 'Room A',
    teacher: 'history',
  },
  {
    id: 'math-2-room-b',
    start: '2025-07-01T10:00:00',
    end: '2025-07-01T11:30:00',
    room: 'Room B',
    teacher: 'french',
  },
  {
    id: 'science-2-room-c',
    start: '2025-07-01T10:00:00',
    end: '2025-07-01T11:30:00',
    room: 'Room C',
    teacher: 'science',
  },
  // 12:00-1:30 PM slots
  {
    id: 'english-2-room-a',
    start: '2025-07-01T12:00:00',
    end: '2025-07-01T13:30:00',
    room: 'Room A',
    teacher: 'english',
  },
  {
    id: 'history-2-room-b',
    start: '2025-07-01T12:00:00',
    end: '2025-07-01T13:30:00',
    room: 'Room B',
    teacher: 'history',
  },
  {
    id: 'math-3-room-c',
    start: '2025-07-01T12:00:00',
    end: '2025-07-01T13:30:00',
    room: 'Room C',
    teacher: 'french',
  },
  // 2:00-3:30 PM slots
  {
    id: 'science-3-room-a',
    start: '2025-07-01T14:00:00',
    end: '2025-07-01T15:30:00',
    room: 'Room A',
    teacher: 'science',
  },
  {
    id: 'english-3-room-b',
    start: '2025-07-01T14:00:00',
    end: '2025-07-01T15:30:00',
    room: 'Room B',
    teacher: 'english',
  },
  {
    id: 'history-3-room-c',
    start: '2025-07-01T14:00:00',
    end: '2025-07-01T15:30:00',
    room: 'Room C',
    teacher: 'history',
  },
];

const rooms = [
  { id: 'Room A', title: 'Room A', eventColor: 'purple' },
  { id: 'Room B', title: 'Room B', eventColor: 'teal' },
  { id: 'Room C', title: 'Room C', eventColor: 'lime' },
];

const classes = [
  { id: 'french', title: 'French', eventColor: 'orange' },
  { id: 'science', title: 'Science', eventColor: 'teal' },
  { id: 'english', title: 'English', eventColor: 'pink' },
  { id: 'history', title: 'History', eventColor: 'indigo' },
];

export default function DynamicResourceProperty() {
  const [resourceProperty, setResourceProperty] = React.useState('room');
  const [events, setEvents] = React.useState(initialEvents);

  const eventModelStructure = React.useMemo(
    () => ({
      title: {
        getter: (event) => `${capitalize(event.teacher)} (${event.room})`,
      },
      resource: {
        getter: (event) => event[resourceProperty],
        setter: (event, newValue) => {
          if (newValue == null) {
            delete event[resourceProperty];
          } else {
            event[resourceProperty] = newValue;
          }
          return event;
        },
      },
    }),
    [resourceProperty],
  );

  return (
    <Stack spacing={2} style={{ width: '100%' }}>
      <ToggleButtonGroup
        exclusive
        onChange={(event, newResourceProperty) => {
          if (newResourceProperty !== null) {
            setResourceProperty(newResourceProperty);
          }
        }}
        value={resourceProperty}
      >
        <ToggleButton value="room">Group by Room</ToggleButton>
        <ToggleButton value="teacher">Group by Teacher</ToggleButton>
      </ToggleButtonGroup>
      <div style={{ height: '500px', width: '100%', overflow: 'auto' }}>
        <EventTimelinePremium
          events={events}
          eventModelStructure={eventModelStructure}
          resources={resourceProperty === 'room' ? rooms : classes}
          defaultVisibleDate={defaultVisibleDate}
          onEventsChange={setEvents}
        />
      </div>
    </Stack>
  );
}
